<template>
  <div class="checkbox" :class="{'infield' : isFieldPage}">
    <span class="checkbox__label">{{placeholder}}</span>
    <input type="checkbox" @change="changed" v-model="val" />
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    isFieldPage: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      val: this.value
    };
  },
  watch: {
    value: function(val) {
      this.val = val;
    }
  },
  methods: {
    changed: function(e) {
      this.$emit("input", e.target.checked);
      this.$emit("action");
      return e.target.value;
    }
  }
};
</script>